<template>
  <div class="overview-loader" :class="{ top: top }">
    <grid-loader class="spinner" :loading="true" :color="'#231e4a'" />
  </div>
</template>

<script>
import GridLoader from 'vue-spinner/src/GridLoader'

export default {
  components: { GridLoader },
  props: {
    top: Boolean
  }
}
</script>

<style scoped>
.overview-loader { /* background: rgba(255, 255, 255, .05); */ border-radius: 7px; bottom: -23px; height: 69px; left: 50%; margin-left: -35px; position: absolute; width: 69px; }
.overview-loader.top { top: 17px; }
.overview-loader .spinner { margin: 6px 0 0 6px; }
</style>



// WEBPACK FOOTER //
// src/components/sports/matches/Loader.vue